import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as React from "react"
import { Button, Col, Row } from "antd"
import { Color, Font, FontSize } from "../../../../constants"
import LocationsOverridePicker from "../../../common/locationsPicker/SingleLocationOverridePicker"
import { AntdIconWrap } from "../../Icons/AntdIconWrap"
import { TooltipPopover } from "../../TooltipPopover/TooltipPopover"

type Props = {
    isNew: boolean
    showLocationsPicker?: Maybe<boolean>
    orderSendEmailComponent?: Maybe<React.ReactNode>
    title: Maybe<string> | Maybe<React.ReactNode>
    isSuperUser?: boolean
    onCancelClicked: () => void
    onCopyOrderIdClicked?: () => void
    renderRightElement?: () => Maybe<React.ReactNode>
}

class DrawerDetailFormHeader extends React.Component<Props> {
    static defaultProps = {
        showLocationsPicker: true,
        orderSendEmailComponent: false,
    }
    renderLocations = () => {
        if (!this.props.isNew && this.props.showLocationsPicker) {
            return (
                <LocationsOverridePicker
                    style={{
                        width: "100%",
                    }}
                />
            )
        }

        return null
    }

    render() {
        const renderLocations = !this.props.isNew && this.props.showLocationsPicker
        return (
            <div className="modal-header-panel">
                <style jsx={true} global={true}>
                    {`
                        .modal-header-panel {
                            padding: 1rem;
                            padding-left: 1.5rem;
                            padding-right: 1.5rem;
                            border-bottom: 1px solid ${Color.antBorder};
                            position: fixed;
                            top: 0;
                            width: 100%;
                            background-color: white;
                            z-index: 9999;
                        }
                        .close-btn-x {
                            color: ${Color.Grey4};
                            font-size: ${FontSize.md};
                        }
                        .close-btn-x:hover,
                        .close-btn-x:focus {
                            cursor: pointer;
                            color: ${Color.Grey6};
                        }
                        .title-button:focus,
                        .title-button:active,
                        .title-button:focus-visible {
                            outline: none !important;
                            box-shadow: none !important;
                            border: none !important;
                            background: transparent !important;
                        }
                    `}
                </style>
                <Row>
                    <Col
                        span={
                            renderLocations || this.props.orderSendEmailComponent || this.props.renderRightElement
                                ? 14
                                : 24
                        }>
                        <a
                            role="button"
                            tabIndex={0}
                            onClick={this.props.onCancelClicked}
                            onKeyPress={this.props.onCancelClicked}>
                            <AntdIconWrap className="close-btn-x" type="close" />
                        </a>
                        {this.props.isSuperUser ? (
                            <Button
                                onClick={this.props.onCopyOrderIdClicked}
                                className="border-none p-0 ml-[1.4rem] title-button"
                                onMouseDown={e => e.preventDefault()}>
                                <TooltipPopover
                                    content={"Copy order ID to clipboard"}
                                    side={"top"}
                                    tooltipClassName="z-[10000] !w-fit">
                                    <span
                                        style={{
                                            fontWeight: `${Font.Bold}`,
                                            fontSize: `${FontSize.md}`,
                                            lineHeight: 2,
                                        }}
                                        className="title">
                                        {this.props.title}
                                    </span>
                                </TooltipPopover>
                            </Button>
                        ) : (
                            <span
                                style={{
                                    paddingLeft: "1.4rem",
                                    fontWeight: `${Font.Bold}`,
                                    fontSize: `${FontSize.md}`,
                                    lineHeight: 2,
                                }}
                                className="title">
                                {this.props.title}
                            </span>
                        )}
                    </Col>
                    {this.props.orderSendEmailComponent && (
                        <Col
                            offset={2}
                            span={8}
                            style={{
                                textAlign: "right",
                            }}>
                            {this.props.orderSendEmailComponent}
                        </Col>
                    )}
                    {!this.props.renderRightElement && renderLocations && (
                        <Col offset={2} span={8}>
                            {this.renderLocations()}
                        </Col>
                    )}
                    {this.props.renderRightElement ? (
                        <Col offset={2} span={8}>
                            {this.props.renderRightElement()}
                        </Col>
                    ) : null}
                </Row>
            </div>
        )
    }
}

export default DrawerDetailFormHeader
